import React, { FC, useCallback, useMemo } from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import { Constants } from '@shared/constants';

export const NextTableSingleDateFilter: FC<any> = ({ column: { filterValue, setFilter } }) => {
  const value = useMemo(() => {
    if (filterValue) {
      return dayjs(filterValue, Constants.DATE_TIME);
    }
    return undefined;
  }, [filterValue]);

  const handleChange = useCallback(
    (date: any) => {
      if (date) {
        setFilter(dayjs(date).format(Constants.DATE_TIME));
      } else {
        setFilter(undefined);
      }
    },
    [setFilter],
  );

  return <DatePicker showTime={true} format={Constants.DATE_TIME} value={value} onChange={handleChange} />;
};
